export const initialServices = ['facebook', 'linkedin', 'twitter', 'xing'];

export const availableServices = [
  {
    name: 'facebook',
    label: 'Facebook',
    url: 'https://www.facebook.com/sharer.php?u=',
  },
  {
    name: 'linkedin',
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/shareArticle?mini=true&url=',
  },
  { name: 'twitter', label: 'Twitter', url: 'https://twitter.com/share?url=' },
  {
    name: 'xing',
    label: 'Xing',
    url: 'https://www.xing.com/social/share/spi?url=',
  },
];

export const HEIGHT = 400;
export const WIDTH = 500;

export const windowPopupSettings = ({
  height = HEIGHT,
  width = WIDTH,
  resizable = 'no',
} = {}) => {
  const top = (window.screen.height - height) / 4;
  const left = (window.screen.width - width) / 2;

  return [
    `width=${width}`,
    `height=${height}`,
    `resizable=${resizable}`,
    `top=${top}`,
    `left=${left}`,
  ];
};
